export default "__VITE_ASSET__C6t3V_By__"